import { useTranslation } from '@wix/yoshi-flow-editor';
import React from 'react';
import { TagName } from '../../../../utils/tagName.const';
import Text, { TextType } from '../../Text/Text';
import { PriceItemDataHooks } from '../PaymentSummary/PriceItem/dataHooks';
import { classes, st } from './Discount.st.css';

export interface DiscountRuleNameProps {
  name: string | undefined;
  align: 'start' | 'end';
  isCart: boolean | undefined;
  calculatedAtCheckout?: boolean;
}

export function DiscountRuleName({
  name,
  isCart,
  calculatedAtCheckout,
  align,
}: DiscountRuleNameProps) {
  const { t } = useTranslation();

  return name ? (
    <span className={st(classes.discountRuleNameRoot, { align })}>
      <Text
        type={TextType.Secondary}
        className={classes.discountRuleName}
        data-hook={PriceItemDataHooks.DiscountRuleName}
      >
        {name}
      </Text>
      {(isCart || calculatedAtCheckout) && (
        <Text
          type={TextType.Secondary}
          className={classes.appliedAtCheckout}
          data-hook={PriceItemDataHooks.CalculatedAtCheckout}
        >
          {t('app.bookings-form.bookings-details.calculated-at-checkout')}
        </Text>
      )}
    </span>
  ) : null;
}

export const PriceBeforeDiscount = ({
  price,
  type,
}: {
  price: string | undefined;
  type: TextType;
}) =>
  price ? (
    <Text
      type={type}
      tagName={TagName.Span}
      className={classes.priceBeforeDiscount}
      data-hook={PriceItemDataHooks.PriceBeforeDiscount}
    >
      {price}
    </Text>
  ) : null;
